import React from 'react';

const Icon = ({ children, size = 24, className = '', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    {children}
  </svg>
);

// --- Transport ---
export const IconPlay = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M6 4l14 8-14 8V4z" fill="currentColor"/>
  </Icon>
);

export const IconPause = ({ size, className }) => (
  <Icon size={size} className={className}>
    <rect x="5" y="4" width="4" height="16" rx="1" fill="currentColor"/>
    <rect x="15" y="4" width="4" height="16" rx="1" fill="currentColor"/>
  </Icon>
);

export const IconSkipBack = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M19 20L9 12l10-8v16z" fill="currentColor"/>
    <rect x="5" y="5" width="2" height="14" rx="0.5" fill="currentColor"/>
  </Icon>
);

export const IconSkipForward = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M5 4l10 8-10 8V4z" fill="currentColor"/>
    <rect x="17" y="5" width="2" height="14" rx="0.5" fill="currentColor"/>
  </Icon>
);

export const IconVolume = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M11 5L6 9H2v6h4l5 4V5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.54 8.46a5 5 0 010 7.07M19.07 4.93a10 10 0 010 14.14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// --- Social ---
export const IconHeart = ({ size, className, filled }) => (
  <Icon size={size} className={className}>
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      fill={filled ? 'currentColor' : 'none'}/>
  </Icon>
);

export const IconComment = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconCommentFilled = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M5.2 5.85h13.6a1.8 1.8 0 011.8 1.8v6.72a1.8 1.8 0 01-1.8 1.8h-7.62l-5.16 3.22v-3.22h-.82a1.8 1.8 0 01-1.8-1.8V7.65a1.8 1.8 0 011.8-1.8z" fill="currentColor"/>
  </Icon>
);

export const IconGem = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M6 3h12l4 6-10 12L2 9l4-6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 9h20M12 21L6 9M12 21l6-12M6 3l6 6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconLibraryBig = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M5 5.5A1.5 1.5 0 016.5 4h3A1.5 1.5 0 0111 5.5v13A1.5 1.5 0 019.5 20h-3A1.5 1.5 0 015 18.5v-13z" fill="currentColor"/>
    <path d="M12.75 5.22a1.5 1.5 0 011.84-1.06l2.9.78a1.5 1.5 0 011.06 1.84l-3.36 12.55a1.5 1.5 0 01-1.84 1.06l-2.9-.78a1.5 1.5 0 01-1.06-1.84l3.36-12.55z" fill="currentColor"/>
    <path d="M7.25 7.25h1.5M14.72 7.1l1.45.39" stroke="#14150d" strokeWidth="1.2" strokeLinecap="round"/>
  </Icon>
);

export const IconShare = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconGlobe = ({ size, className }) => (
  <Icon size={size} className={className}>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2 12h20M12 2c2.5 2.74 3.88 6.32 3.88 10S14.5 19.26 12 22M12 2C9.5 4.74 8.12 8.32 8.12 12S9.5 19.26 12 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconInstagram = ({ size, className }) => (
  <Icon size={size} className={className}>
    <rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="16.75" cy="7.25" r="0.9" fill="currentColor"/>
  </Icon>
);

export const IconX = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M4 4l16 16M20 4L4 20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
  </Icon>
);

export const IconCopy = ({ size, className }) => (
  <Icon size={size} className={className}>
    <rect x="8" y="8" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5 15H4a2 2 0 01-2-2V5a2 2 0 012-2h8a2 2 0 012 2v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </Icon>
);

// --- Dashboard ---
export const IconEye = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
  </Icon>
);

export const IconSparkle = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconChart = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M18 20V10M12 20V4M6 20v-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconEdit = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconTrash = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M3 6h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// --- Navigation ---
export const IconPin = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/>
  </Icon>
);

export const IconGear = ({ size, className }) => (
  <Icon size={size} className={className}>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconFolder = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconBack = ({ size, className }) => (
  <Icon size={size} className={className}>
    <polyline points="15 18 9 12 15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconClose = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconArrowUp = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconArrowDown = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M12 5v14M19 12l-7 7-7-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

// --- Brand ---
export const IconGoogle = ({ size = 20, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className}>
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export const IconApple = ({ size = 20, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

// --- Notification types ---
export const IconBell = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconUser = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
);

export const IconMusic = ({ size, className }) => (
  <Icon size={size} className={className}>
    <path d="M9 18V5l12-2v13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="6" cy="18" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="18" cy="16" r="3" stroke="currentColor" strokeWidth="1.5"/>
  </Icon>
);
